module.exports = __webpack_public_path__ + "img/Pfingstbaum-Baumtruppe.ec5030b0.jpg";